export default __webpack_public_path__ + "static/media/coordinadores_formato.54e10369.xlsx";